const initialState = {open:false, data:''};

export default function reducer(state=initialState, action){

    switch (action.type){
        case "OPEN_PDF_VIEWER":{
            return {...state,
                open:true,
                data:action.payload
            }
        }
        case "CLOSE_PDF_VIEWER":{
            return {...state,
                open:false
            }
        }
        default: {
            return state;
        }
    }
};


// WEBPACK FOOTER //
// ./src/reducers/shared/pdf_viewer.js